import { Img } from "components";
import TextArea from "../components/TextArea";
import AvatarVideo from "../components/AvatarVideo";
import Lottie from "lottie-react";
import DownArrow from "assets/images/DownArrow.json";
import Wrapper from "../components/Wrapper";

const videoLinks = [
  {url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/checkout.mp4"}
]

const CheckoutLiveWebsite = () => {
  return (
    <Wrapper
      title={"Checkout Live Website"}
      description={<>This is the responsive demo—the exact way your school’s site will adapt to <br /> phones, tablets, and desktops.</>}
      descriptionSize="text-[2.6vh]"
      stepperNotRequired
      innerBodyStyle={{paddingBottom: "0px"}}
      innerBodyClasses="pb-[0vh] pb-[0px]"
      videoLinks={videoLinks}
      body={<>
        <div className="relative bg-[url(/public/images/soomuch-demo/background-secondary.svg)] bg-no-repeat bg-cover bg-center h-[60vh]">
        <div className="absolute inset-0 z-10">
         <div
              className="w-[70vw] mx-auto rounded-t-xl border-b-0 bg-[#FBF1E7] from-[#FBF1E7] via-white to-blue-50 shadow-lg space-y-8 h-[100%]"
              style={{
                borderTop: "2px solid black",
                borderLeft: "2px solid black",
                borderRight: "2px solid black",
              }}
            >
              <div className="flex items-center justify-between px-4 py-3 text-gray-700 border-b">
                <div className="flex items-center space-x-2">
                  <Img src="images/soomuch-demo/logo.svg" className="w-[15vh]" />
                </div>

                <div className="flex items-center gap-4 text-gray-700 text-[1.5vh]">
                  <a href="#" className="hover:underline">
                    About Us
                  </a>
                  <a href="#" className="hover:underline">
                    Our Educators
                  </a>
                  <a href="#" className="hover:underline">
                    Gallery
                  </a>
                  <a href="#" className="hover:underline flex items-center gap-1">
                    Special courses
                    <div className="cursor-pointer w-4 h-4 bg-[url(/public/images/soomuch-demo/DownArrowBlack.svg)] bg-no-repeat bg-cover bg-center"></div>
                  </a>
                  <a href="#" className="hover:underline flex items-center gap-1">
                    Extracurricular activities
                    <div className="cursor-pointer w-4 h-4 bg-[url(/public/images/soomuch-demo/DownArrowBlack.svg)] bg-no-repeat bg-cover bg-center"></div>
                  </a>
                </div>

                <div className="text-[1.5vh] flex items-center space-x-4">
                  <div className="flex items-center border border-[#DF7910] rounded-full overflow-hidden font-medium">
                    <div className="bg-[#DF7910] text-[white] px-[1vh] py-1 flex items-center gap-2 rounded-l-full">
                      <div className="w-3 h-3 bg-[url(/public/images/soomuch-demo/Vector.svg)] bg-no-repeat bg-cover bg-center"></div>
                      <span className="text-[#fff]">24/7</span>
                    </div>
                    <div className="px-[1vh] py-1 text-[#333]">+91 80008328458</div>
                  </div>

                  <button className="bg-blue-900 text-white px-4 py-[0.4rem] text-[#fff] outline-none hover:bg-blue-800">
                    Sign in
                  </button>
                </div>
              </div>

              <div className="px-6 text-center">
                <p className="text-smd_blue-normal font-inter font-manropeEB text-[2.7vh] leading-relaxed">
                  You will soon view a live demo of a fully functional preview
                  <br />
                  of your school’s future website! Every feature you see here
                  <br />
                  will be yours once we go live.
                </p>

                <div className="flex justify-center">
                  <Lottie animationData={DownArrow} style={{ width: 90, height: 100 }} />
                </div>
                <button type="button" onClick={() => window.open("https://newdemo.soomuch.ai/", "_blank")} className="bg-smd_blue-normal text-[#fff] text-[2.4vh] px-6 py-3 rounded-xl hover:bg-blue-800">
                  Let's Take A Quick Tour
                </button>
              </div>
            </div>
        </div>
        </div>
      </>}
    />
    // <div className="flex justify-center min-h-screen">
    //   <div className="container font-manrope p-9 pb-0 flex flex-col justify-between w-full">
    //     <div className="flex">
    //       <div className="grid grid-cols-3 gap-4 w-full">
    //         <div>
    //           <Img src="images/soomuch-demo/logo.svg" />
    //         </div>
    //         <div className="text-center self-end space-y-2">
    //           <h1 className="font-raveo text-smd_blue-normal text-4xl font-[1000] leading-[120%] tracking-[-1%]">
    //             Checkout Live Website
    //           </h1>
    //           <p className="text-sm">
    //             This is the responsive demo—the exact way your school’s site
    //             will adapt to phones, tablets, and desktops.
    //           </p>
    //         </div>
    //         <div className="flex justify-end">
    //           <Img src={"/images/soomuch-demo/VideoLoader.png"} className="w-[18vh] h-[18vh] object-top object-cover rounded-lg" />
    //         </div>
    //       </div>
    //     </div>
    //     <div className="bg-[url(/public/images/soomuch-demo/background-secondary.svg)] bg-no-repeat bg-cover bg-center">
    //       <div className="relative w-full max-w-[1100px] mx-auto overflow-hidden">
    //         <div className="absolute -top-16 -left-16 w-64 h-64 bg-orange-300 opacity-30 rounded-full blur-3xl z-0"></div>
    //         <div className="absolute -bottom-16 -right-16 w-64 h-64 bg-blue-300 opacity-30 rounded-full blur-3xl z-0"></div>

    //         <div
    //           className="relative z-10 rounded-t-xl border-b-0 bg-[#FBF1E7] from-[#FBF1E7] via-white to-blue-50 shadow-lg space-y-8"
    //           style={{
    //             borderTop: "2px solid black",
    //             borderLeft: "2px solid black",
    //             borderRight: "2px solid black",
    //           }}
    //         >
    //           <div className="flex items-center justify-between px-4 py-3 text-sm text-gray-700 border-b">
    //             <div className="flex items-center space-x-2">
    //               <Img src="images/soomuch-demo/logo.svg" className="w-36 h-6" />
    //             </div>

    //             <div className="flex items-center gap-5 text-gray-700">
    //               <a href="#" className="hover:underline">
    //                 About Us
    //               </a>
    //               <a href="#" className="hover:underline">
    //                 Our Educators
    //               </a>
    //               <a href="#" className="hover:underline">
    //                 Gallery
    //               </a>
    //               <a href="#" className="hover:underline flex items-center gap-1">
    //                 Special courses
    //                 <div className="cursor-pointer w-4 h-4 bg-[url(/public/images/soomuch-demo/DownArrowBlack.svg)] bg-no-repeat bg-cover bg-center"></div>
    //               </a>
    //               <a href="#" className="hover:underline flex items-center gap-1">
    //                 Extracurricular activities
    //                 <div className="cursor-pointer w-4 h-4 bg-[url(/public/images/soomuch-demo/DownArrowBlack.svg)] bg-no-repeat bg-cover bg-center"></div>
    //               </a>
    //             </div>

    //             <div className="flex items-center space-x-4">
    //               <div className="flex items-center border border-[#DF7910] rounded-full overflow-hidden text-xs font-medium">
    //                 <div className="bg-[#DF7910] text-white px-2 py-1 flex items-center gap-2 rounded-l-full">
    //                   <div className="w-3 h-3 bg-[url(/public/images/soomuch-demo/Vector.svg)] bg-no-repeat bg-cover bg-center"></div>
    //                   <span className="text-[#fff]">24/7</span>
    //                 </div>
    //                 <div className="px-2 py-1 text-[#333]">+91 80008328458</div>
    //               </div>

    //               <button className="bg-blue-900 text-white text-xs px-4 py-[0.4rem] text-[#fff] outline-none hover:bg-blue-800">
    //                 Sign in
    //               </button>
    //             </div>
    //           </div>

    //           <div className="px-6 py-10 text-center">
    //             <p className="text-blue-900 font-manropeSB text-lg leading-relaxed">
    //               You will soon view a live demo of a fully functional preview
    //               <br />
    //               of your school’s future website! Every feature you see here
    //               <br />
    //               will be yours once we go live.
    //             </p>

    //             <div className="flex justify-center">
    //               <Lottie animationData={DownArrow} style={{ width: 90, height: 100 }} />
    //             </div>
    //             <button type="button" onClick={() => window.open("https://newdemo.soomuch.ai/","_blank")} className="bg-blue-900 text-[#fff] text-md px-6 py-2 rounded-md hover:bg-blue-800">
    //               Let's Take A Quick Tour
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default CheckoutLiveWebsite;
